export default __webpack_public_path__ + "static/media/022-coffee.ea9094be.svg";